module.exports = __webpack_public_path__ + "img/webstream-img.1c568e03.png";